import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TopComponent } from './top.component';
import { RoleGuard } from '../../guard/role.guard';
import { AuthGuard } from '../../guard/auth.guard';
var TopRoutingModule = /** @class */ (function () {
    function TopRoutingModule() {
    }
    TopRoutingModule.decorators = [
        { type: NgModule, args: [{
                    imports: [RouterModule.forChild([
                            { path: 'top', component: TopComponent, canActivate: [AuthGuard, RoleGuard] }
                        ])],
                    exports: [RouterModule]
                },] }
    ];
    return TopRoutingModule;
}());
export { TopRoutingModule };
//# sourceMappingURL=top-routing.module.js.map